<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="pl-12 pr-12 col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              depressed
              dark
              color="#1B437C"
              @click="
                ;(alert = !alert),
                  chkAdd(),
                  (dialogAdd = true),
                  validate('ADD'),
                  getDataBranch(),
                  chkaddFilterItem(),
                  chkaddProductExchangeRate()
              "
            >
              <v-icon left>mdi-plus-box-multiple</v-icon>
              Add Lot
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-dialog v-model="dialogAdd" persistent :max-width= "resCol === '12' ? '' : '40%'" :fullscreen="resCol === '12' ? true : false">
            <v-card class="text-center">
              <v-card-text>
                <v-container>
                  <v-col class="text-right">
                    <v-btn
                      small
                      color="#E0E0E0"
                      @click=";(dialogAdd = false), clearData()"
                    >
                      <v-icon color="#173053">mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                  <v-row justify="center">
                    <v-col cols="4" class="text-center">
                      <v-col class="text-center">
                        <v-img
                          class="v-margit_img_reward"
                          :src="require('@/assets/Device.svg')"
                          max-width="330"
                        ></v-img>
                      </v-col>
                    </v-col>

                    <v-col cols="8" class="v-margit_text_add">
                      <v-col class="text-center">
                        <v-img
                          class="v_text_add"
                          :src="require('@/assets/Grouptitle.svg')"
                        ></v-img>
                      </v-col>
                      <!-- <v-alert
                        v-if="res.length >= 10"
                        :value="alert"
                        outlined
                        type="warning"
                        prominent
                        border="left"
                        elevation="24"
                      >
                        จำนวนสมาชิกใกล้จะครบที่กำหนด
                      </v-alert> -->
                      <v-card
                        max-width="600"
                        class="mx-auto"
                        v-show="this.formAdd.productExchangeRateId === ''"
                        v-if="session.data.userTypeGroup === 'Operation'"
                      >
                        <!-- {{ProductExchangeRate}} -->
                        <v-container>
                          <v-row dense pt-3>
                            <v-col
                              v-for="(item, i) in filterItem"
                              :key="i"
                              cols="6"
                            >
                              <div>
                                <v-card color="#1b437c" dark>
                                  <!-- {{filterItem}} -->
                                  <v-card-title>
                                    <h2>
                                      {{ item.text }}
                                    </h2>
                                  </v-card-title>
                                  <div
                                    class="d-flex flex-no-wrap justify-space-between"
                                  >
                                    <div>
                                      <v-card-subtitle>
                                        <h5>
                                          อัตราแลกเปลี่ยน 1 คะแนน ต่อ
                                          {{ item.exchangeRate }} บาท
                                        </h5>
                                      </v-card-subtitle>
                                    </div>
                                  </div>
                                  <v-card-actions>
                                    <v-btn
                                      class="mx-auto"
                                      text
                                      color="primary"
                                      @click="
                                        addExchange(item), getDataBranch()
                                      "
                                    >
                                      เลือก
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                      <v-card
                        max-width="600"
                        class="mx-auto"
                        v-show="this.formAdd.productExchangeRateId === ''"
                        v-if="session.data.userTypeGroup !== 'Operation'"
                      >
                        <!-- {{session.data.userTypeGroup}} -->
                        <v-container>
                          <v-row dense pt-3>
                            <v-col
                              v-for="(item, i) in ProductExchangeRate"
                              :key="i"
                              cols="6"
                            >
                              <div class="box" @click="addExchange(item)">
                                <v-card color="#1b437c" dark class="pa-4">
                                  <!-- {{ProductExchangeRate}} -->
                                  <v-card-title>
                                    <h3 class="mb-0">
                                      {{ item.text }}
                                    </h3>
                                  </v-card-title>
                                  <div
                                    class="d-flex flex-no-wrap justify-space-between"
                                  >
                                    <div>
                                      <v-card-subtitle>
                                        <h5 style="text-align: left;">
                                          อัตราแลกเปลี่ยน 1 คะแนน ต่อ
                                          {{ item.exchangeRate }} บาท
                                        </h5>
                                      </v-card-subtitle>
                                    </div>
                                  </div>
                                  <v-btn
                                    class="mx-auto"
                                    outlined
                                    @click="addExchange(item)"
                                  >
                                    เลือก
                                  </v-btn>
                                  <!-- <v-card-actions>
                              </v-card-actions> -->
                                </v-card>
                              </div>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card>
                      <v-form
                        ref="form_add"
                        v-model="validAdd"
                        lazy-validation
                        v-show="this.formAdd.productExchangeRateId !== ''"
                      >
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <v-text-field
                              v-model="formAdd.lotName"
                              label="ชื่อ Lot"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <v-text-field
                              disabled
                              v-model="Exchange"
                              :items="Exchange"
                              dense
                              outlined
                              :rules="[rules.required]"
                              label="Exchange Rate"
                            ></v-text-field>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <VuetifyMoney
                              v-model="formAdd.amount"
                              label="จำนวนเงิน"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <VuetifyMoney
                              v-model="formAdd.countLot"
                              label="จำนวน"
                              dense
                              outlined
                              required
                              :rules="[rules.required]"
                              v-bind:options="options2"
                            />
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row style="height: 60px">
                            <v-select
                              v-model="formAdd.masBranchID"
                              :items="dataBranch"
                              label="สาขา"
                              dense
                              outlined
                              :rules="[rules.required]"
                            ></v-select>
                          </v-row>
                        </v-col>
                      </v-form>
                      <v-col id="margin">
                        <v-row justify="center">
                          <v-btn
                            elevation="2"
                            x-large
                            dark
                            color="#173053"
                            :disabled="!validAdd"
                            :loading="loadingAdd"
                            @click="addData()"
                          >
                            <v-icon left>mdi-checkbox-marked-circle</v-icon>
                            เพิ่ม
                          </v-btn>
                        </v-row>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end add -->

          <!-- View -->
          <v-dialog
            v-model="dialogViewQR"
            persistent
            max-width="80%"
            v-if="dataViewQR.length > 0"
          >
            <v-card>
              <v-card-text>
                <v-form>
                  <v-container>
                    <v-row class="no-gutters">
                      <v-col
                        v-for="(items, index) in dataViewQR"
                        :key="index"
                        cols="2"
                        class="text-center ma-0 pa-6 frameQR"
                      >
                        <span class="shopname">{{ session.data.name }}</span>
                        <qrcode-vue
                          :value="items.qrCodeURL"
                          :size="size"
                          level="H"
                        ></qrcode-vue>
                        <span class="point">{{ items.point }}</span>
                        <span class="summary">คะแนน</span>
                        <br />
                        <span class="summary" color="#173053"
                          >*สแกนเพื่อรับคะแนน</span
                        >
                      </v-col>
                    </v-row>
                    <div></div>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogViewQR = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end View -->

          <!-- edit -->
          <v-dialog v-model="dialogEdit" persistent max-width="30%">
            <v-card class="text-center">
              <v-card-text>
                <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn small color="#E0E0E0" @click="dialogEdit = false">
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-img
                          class="v-img-margit"
                          :src="require('@/assets/VectorEdit.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="6" class="v-margit_text_add">
                        <v-img
                          class="v_text"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-col cols="12">
                      <v-row style="height: 20px">
                        <v-subheader id="subtext">ชื่อ LOT</v-subheader>
                      </v-row>
                      <v-row style="height: 55px">
                        <v-col cols="12">
                          <v-text-field
                            v-model="formUpdate.lotName"
                            placeholder="ชื่อ Lot"
                            dense
                            :rules="[rules.required]"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- dialog Printer -->
          <v-dialog v-model="dialogPrinter" persistent max-width="70%">
            <v-card>
              <iframe id="pdfV" style="width:100%; height: 1200px"> </iframe>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  dark
                  class="btn-color"
                  @click="dialogPrinter = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- end -->

          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="3" v-if="dataReady" style="border-radius: 10px !important;">
              <v-card-title>
                <v-text-field
                  style="padding-left: 20px !important;padding-right: 20px !important;padding-top: 7px !important;"
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  dense
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem1"
                  :search="searchAll2"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.amount`]="{ item }">
                    {{ formatNumber(item.amount) }}
                  </template>
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ thaiFormattedDate(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          x-small
                          @click.stop="
                            ;(dialogEdit = true),
                              getDataById(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip> -->
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          x-small
                          @click.stop="
                            ;(dialogViewQR = true), getDataQRCode(item)
                          "
                        >
                          <v-icon dark color="green accent-3">
                            mdi-qrcode-scan
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>เปิด Qr code</span>
                    </v-tooltip> -->
                    <v-tooltip bottom v-if="session.data.shopId !== 'U8e5495902728477dd8eb9167cbb624ed'">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          dark
                          fab
                          x-small
                          :loading="loadingBTN"
                          @click.stop="; loadingBTN=true; printerV2(item)"
                        >
                          <v-icon> mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>ปริ้น Qr code</span>
                    </v-tooltip>
                    <v-tooltip bottom v-else>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          dark
                          fab
                          x-small
                          @click.stop=";(dialogPrinter = true), printer(item)"
                        >
                          <v-icon> mdi-printer </v-icon>
                        </v-btn>
                      </template>
                      <span>ปริ้น Qr code</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
        </v-row>
      </div>
      <v-col class="InputData" cols="12" style="display: flex;justify-content: center;">
        <v-card class="p-3" style="width: 95%;border-radius: 20px !important;">
          <h3 class="mb-2" style="font-size: 18.72px !important"><v-icon>mdi-map-marker-radius</v-icon>ข้อมูลตำแหน่งที่ลูกค้ารับคะแนน</h3>
          <div>
            <v-alert
              dense
              type="info"
              dismissible
            >
              <div class="mb-0" style="color: white !important;">1. ระบบจะบันทึกข้อมูลที่อยู่หลังจากลูกค้ารับคะแนนจาก Qr code lot เท่านั้น</div>
              <div class="mb-0" style="color: white !important;">2. ระบบจะบันทึกข้อมูลที่อยู่หลังจากลูกค้ากดยอมรับในการแชร์ตำแหน่ง</div>
              <div class="mb-0" style="color: white !important;">3. ข้อมูลที่แสดงในหน้านี้มาจากลูกค้าเก็บคะแนนจาก QRcode เท่านั้นไม่เกี่ยวข้องกับแจกคะแนนผ่านเบอร์โทร</div>
            </v-alert>
          </div>
          <div style="display: flex;">
            <v-btn outlined class="mb-3 mr-5" @click="menufilter = !menufilter"><v-icon class="iconify" data-icon="mage:filter"></v-icon> ตัวกรองค้นหา</v-btn>
            <v-btn outlined class="mb-3" color="red" @click="selectedItem = [], selectBranch = null, lotIdForfilter = [], fliterNameZone = null, getQrCodeAddress()"><v-icon class="iconify"></v-icon> ล้างตัวกรอง</v-btn>
          </div>
          <v-slide-x-transition>
            <div v-if="menufilter" style="border-radius: 10px;border: solid #cecece;padding: 20px;margin-bottom: 20px;" transition="scroll-y-transition">
              <div class="mb-1" style="font-size: 20px"><v-icon class="iconify" data-icon="mage:filter"></v-icon> ตัวกรองค้นหา</div>
              <v-row>
                <v-col cols="6">
                  <v-select
                    :items="dataBranch"
                    v-model="selectBranch"
                    dense
                    outlined
                    label="ค้นหาสาขา"
                    attach
                    @change="filterLotNameByBranch(selectBranch)"
                    prepend-inner-icon="mdi-view-list-outline"
                    :menu-props="{ bottom: true, offsetY: true }"
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-select
                    :items="lotIdForfilter"
                    v-model="selectedItem"
                    item-value="lotId"
                    item-text="branchAndLotName"
                    dense
                    outlined
                    label="ค้นหาชื่อล๊อต"
                    attach
                    multiple
                    prepend-inner-icon="mdi-view-list-outline"
                    :no-data-text="`กรุณาเลือกสาขา`"
                    :menu-props="{ bottom: true, offsetY: true }"
                  ></v-select>
                </v-col>
                <!-- <v-col cols="6">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dates"
                        label="ค้นหาตามวันที่ลูกค้ารับคะแนน"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        clearable
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dates"
                      no-title
                      scrollable
                      range
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu1 = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu1.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col> -->
              </v-row>
              <v-btn block style="color:white !important" color="rgb(28 67 124)" @click="getQrCodeAddress()"><v-icon>mdi-magnify</v-icon> ค้นหา</v-btn>
            </div>
          </v-slide-x-transition>
          <v-row>
            <v-col cols="">
              <v-card class="cardMap2 px-7" style="display: flex;justify-content: space-between;">
                <div>
                  <div style="font-size: 20px;">Qrcode ทั้งหมด </div>
                  <div>{{allQrcode}} คิวอาร์โค้ด</div>
                </div>
                <!-- <div>
                  <v-avatar>
                    <img
                      :src="require('@/assets/check.png')"
                      alt="John"
                    >
                  </v-avatar>
                </div> -->
              </v-card>
            </v-col>
            <v-col cols="">
              <v-card class="cardMap2 px-7" style="display: flex;justify-content: space-between;">
                <div>
                  <div style="font-size: 20px;">Qrcode ที่ถูกใช้แล้ว </div>
                  <div>
                    <div>{{ countUsedQrcode }} คิวอาร์โค้ด</div>
                    <div style="display: flex;">
                      <div style="display:flex">มีที่อยู่ <div class="mb-0 mr-2 ml-1" style=" color:green">{{ haveLocation }}</div>|</div>
                      <div style="display:flex" class="ml-2">ไม่มีที่อยู่ <div class="mb-0 ml-1" style=" color:lightcoral">{{ notLocation }}</div></div>
                    </div>
                  </div>
                </div>
                <!-- <div>
                  <v-avatar>
                    <img
                      :src="require('@/assets/check.png')"
                      alt="John"
                    >
                  </v-avatar>
                </div> -->
              </v-card>
            </v-col>
            <v-col cols="">
              <v-card class="cardMap2 px-7" style="display: flex;justify-content: space-between;">
                <div>
                  <div style="font-size: 20px;">Qrcode ที่ยังถูกไม่ถูกใช้</div>
                  <div>{{ countGetQrcode }} คิวอาร์โค้ด</div>
                </div>
                <!-- <div>
                  <v-avatar>
                    <img
                      :src="require('@/assets/minus-button.png')"
                      alt="John"
                    >
                  </v-avatar>
                </div> -->
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="">
              <v-card @click="filterZone('กลาง')" class="cardMap2" @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hovering': isHovering}" style="border:solid #EBD63D 4px;border-radius: 30px !important;">
                <div>ภาคกลาง</div>
                <div>{{center1}} ครั้ง</div>
              </v-card>
            </v-col>
            <v-col cols="" >
              <v-card @click="filterZone('เหนือ')" class="cardMap2" @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hovering': isHovering}" style="border:solid #FF99FF 4px;border-radius: 30px !important;">
                <div>ภาคเหนือ</div>
                <div>{{ north }} ครั้ง</div>
              </v-card>
            </v-col>
            <v-col cols="">
              <v-card @click="filterZone('ใต้')" class="cardMap2" @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hovering': isHovering}" style="border:solid #69C2C2 4px;border-radius: 30px !important;">
                <div>ภาคใต้</div>
                <div>{{ south }} ครั้ง</div>
              </v-card>
            </v-col>
            <v-col cols="" >
              <v-card @click="filterZone('ตะวันออกเฉียงเหนือ')" class="cardMap2" @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hovering': isHovering}" style="border:solid #E6AF73 4px;border-radius: 30px !important;">
                <div>ภาคตะวันออกเฉียงเหนือ</div>
                <div>{{ northEast }} ครั้ง</div>
              </v-card>
            </v-col>
            <v-col cols="">
              <v-card @click="filterZone('ตะวันออก')" class="cardMap2" @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hovering': isHovering}" style="border:solid #D0E382 4px;border-radius: 30px !important;">
                <div>ภาคตะวันออก</div>
                <div>{{ east }} ครั้ง</div>
              </v-card>
            </v-col>
            <v-col cols="">
              <v-card @click="filterZone('ตะวันตก')" class="cardMap2" @mouseover="isHovering = true" @mouseout="isHovering = false" :class="{'hovering': isHovering}" style="border:solid #8A9FD2 4px;border-radius: 30px !important;">
                <div>ภาคตะวันตก</div>
                <div>{{ west }} ครั้ง</div>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="9">
              <GmapMap
                :center="{lat:13.736717, lng:100.523186}"
                :zoom="6"
                map-type-id="terrain"
                style="width: 100%; height: 600px;border-radius: 20px !important;"
              >
                <GmapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :clickable="true"
                  :draggable="true"
                  @click="center=m.position"
                />
              </GmapMap>
            </v-col>
            <v-col cols="3">
              <v-card min-height="600px" style="border-radius: 20px;background-color: rgb(28 67 124 / 83%);box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;">
                <!-- <v-card-title>leader boards</v-card-title> -->
                <div class="card-titel-ja"><v-icon class="iconify pb-2" color="green" data-icon="iconoir:leaderboard-star"></v-icon>Leader boards {{ fliterNameZone ? 'ภาค' + fliterNameZone : '' }}</div>
                <div style="height: 260px;" class="pa-2 mt-2">
                  <iconify-icon icon="clarity:export-solid"></iconify-icon>
                  <div class="mb-2" style="color: white;display: flex;justify-content: space-between;">
                    จังหวัดมีการเก็บคะแนนมากที่สุด
                    <v-btn class="btn-color" icon>
                      <download-excel
                        class="btn btn-default"
                        :data="export_data_province"
                        :fields="export_field_province"
                        :type="exportType"
                        :worksheet="exportWorksheet"
                        :name="exportFileProvince"
                      >
                      <v-icon class="iconify" color="white" data-icon="clarity:export-solid"></v-icon>
                      </download-excel>
                    </v-btn>
                  </div>
                  <div v-for="(item, index) in provinceDataLeaderBoard" :key="index">
                    <div style="background-color: white;box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;padding: 10px;border-radius: 20px;margin-bottom: 5px">
                      <div style="display: flex;justify-content: space-between;">
                        <div>
                          <v-icon :color="index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : ''" v-if="index < 3">mdi-crown</v-icon>
                          {{ item.province }}
                        </div>
                        <div style="align-items: center;display: flex;">{{ item.count }} ครั้ง</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="height: 260px;"  class="pa-2">
                  <div style="padding: 10px;padding-top: 0px;color: white;display: flex;justify-content: space-between;">
                    สมาชิกเก็บคะแนนมากที่สุด
                    <v-btn class="btn-color" icon>
                      <download-excel
                        class="btn btn-default"
                        :data="export_data_member"
                        :fields="export_field_member"
                        :type="exportType"
                        :worksheet="exportWorksheet"
                        :name="exportFileMember"
                      >
                      <v-icon class="iconify" color="white" data-icon="clarity:export-solid"></v-icon>
                      </download-excel>
                    </v-btn>
                  </div>
                  <div v-for="(item, index) in memberDataLeaderBoard" :key="index">
                    <div style="background-color: white;box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;padding: 10px;border-radius: 20px;margin-bottom: 5px">
                      <div style="display: flex;justify-content: space-between;">
                        <div>
                          <v-icon :color="index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : index === 2 ? '#CD7F32' : ''" v-if="index < 3">mdi-crown</v-icon>
                          <v-avatar class="ml-2">
                            <img
                              :src="item.picture"
                              alt="John"
                            >
                          </v-avatar>
                          {{ item.name}}
                        </div>
                        <div style="align-items: center;display: flex;">{{ item.count }} ครั้ง</div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-main>
  </div>
</template>
<script>
// import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import XLSX from 'xlsx'
import JsonExcel from 'vue-json-excel'
import readXlsxFile from 'read-excel-file'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
import pdfMake from 'pdfmake'
import pdfFonts from '../../assets/my-fonts/custom-fonts.js' // 1. import custom fonts

// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue,
    XLSX,
    readXlsxFile,
    downloadExcel: JsonExcel
    // QrcodeStream
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  computed: {
    resCol () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '12'
        case 'sm':
          return '12'
        case 'md':
          return '6'
        case 'lg':
          return '6'
        case 'xl':
          return '6'
      }
      console.log(
        'this.$vuetify.breakpoint.name',
        this.$vuetify.breakpoint.name
      )
    }
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      loadingBTN: false,
      isHovering: false,
      menufilter: false,
      lotIdForfilter: [],
      dates: [],
      menu1: false,
      selectedItem: [],
      selectBranch: null,
      dataHaveLocation: [],
      // center: null,
      PK: '',
      path: '/qrcodeLot/', // Path Model
      returnLink: '/Tool/CollectQRCodeLot',
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'Collect QRCode Lot',
          disabled: false,
          href: '/Tool/CollectQRCodeLot'
        }
      ],
      options2: {
        locale: 'en-US',
        prefix: '',
        suffix: '',
        length: 9,
        precision: 0
      },
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      camera: 'auto',
      result: null,
      showScanConfirmation: false,
      formRedeem: {
        shopId: '',
        rewardId: '',
        rewardCode: '',
        lineUserId: '',
        totalPoint: '',
        levelName: ''
      },
      // End Menu Config
      dataReady: true,
      dataShowQR: false,
      dialogRedeem: false,
      dialogPrinter: false,
      size: 120, // QR Code
      canvas: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      dialogViewLot: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      // Dialog Config ADD EDIT DELETE IMPORT
      dialogAdd: false,
      dialogAddLot: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogImport: false,
      dialogView: false,
      dialogViewAdd: false,
      dialogViewQR: false,
      // END Dialog Config ADD EDIT DELETE
      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),
      // Search All
      searchAll: '',
      searchAll2: '',
      // Search Advanced
      search: {
        masAgeCode: '',
        masAgeName: '',
        create_date_start: '',
        create_date_end: '',
        last_date_start: '',
        last_date_end: ''
      },
      formView: {
        lineName: '',
        linePicture: '',
        rewardName: '',
        rewardSubName: '',
        rewardPictureUrl: ''
      },
      formAdd: {
        productExchangeRateId: '',
        amount: 0,
        point: 0,
        status: 'waiting',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        lotId: '',
        countLot: '',
        branchName: '',
        masBranchID: '',
        lotName: '',
        liffId: ''
      },
      formUpdate: {
        id: '',
        productExchangeRateId: '',
        amount: 0,
        point: 0,
        status: '',
        CREATE_USER: '',
        LAST_USER: '',
        shopId: '',
        CREATE_DATE: '',
        LAST_DATE: '',
        lotId: '',
        branchName: '',
        masBranchID: '',
        lotName: ''
      },
      formUpdateItem: {
        lotName: ''
      },
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      // End Form Config ADD EDIT
      // Data Table Config
      columns: [
        { text: 'เลขล็อต', value: 'lotId' },
        { text: 'ชื่อล็อต', value: 'lotName' },
        // { text: 'รหัสของอัตราแลกเปลี่ยน', value: 'productExchangeRateId' },
        { text: 'คะแนนที่แจก', value: 'point' },
        { text: 'จำนวนที่สร้าง', value: 'Count' },
        { text: 'ใช้แล้ว', value: 'Uses' },
        { text: 'คงเหลือ', value: 'Gets' },

        // { text: 'Status', value: 'point' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'สาขา', value: 'branchName' },
        // { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      dataViewQR: [],
      ProductExchangeRate: [],
      dataItem: [],
      dataItem1: [],
      dataItemViewLot: [],
      dataBranch: [],
      validAdd: true,
      validAddLot: true,
      validUpdate: true,
      dailogViewRedeem: false,
      statusViewRedeem: false,
      alert: false,
      res: [],
      pointMultiply: null,
      filterItem: [],
      Exchange: '',
      print: [],
      loadingAdd: false,
      loadingEdit: false,
      position: [],
      markers: [],
      export_data: null,
      export_data_province: null,
      export_data_member: null,
      countUsedQrcode: 0,
      allQrcode: 0,
      countGetQrcode: 0,
      center1: 0,
      north: 0,
      south: 0,
      east: 0,
      west: 0,
      northEast: 0,
      dataQrcodeLot: null,
      fliterNameZone: null,
      notLocation: 0,
      haveLocation: 0,
      export_field: {
        linUserId: 'liffUserId',
        IdmemberBarcode: 'IdbarCodeMember',
        ชื่อไลน์: 'name',
        ชื่อ: 'nameCustomer',
        เพศ: 'gender',
        เบอร์โทรศัพท์: 'tel',
        คะแนนที่ได้รับ: 'collectPoint',
        คะแนนที่ถูกใช้: 'redeemPoint',
        คะแนนคงเหลือ: 'currentPoint',
        คะแนนที่จะถูกตัดเดือนนี้: 'balancePoint',
        วันเกิด: 'birthDay',
        ระดับ: 'LevelName',
        วันที่สมัครสมาชิก: 'CREATE_DATE'
      },
      export_field_member: {
        linUserId: 'liffUserId',
        ชื่อไลน์: 'name',
        ชื่อ: 'nameCustomer',
        เพศ: 'gender',
        เบอร์โทรศัพท์: 'tel',
        วันเกิด: 'birthDay',
        ระดับ: 'LevelName',
        จำนวนครั้งที่เก็บคะแนน: 'count',
        คะแนนที่ได้รับ: 'collectPoint',
        คะแนนคงเหลือ: 'currentPoint',
        วันที่สมัครสมาชิก: 'CREATE_DATE'
      },
      export_field_province: {
        จังหวัด: 'province',
        ภาค: 'zone',
        จำนวนครั้งที่เก็บคะแนน: 'count'
      },
      exportType: 'xls',
      exportFileName: 'List-Qrcode.xls',
      exportFileMember: 'Members-collect-most-point.xls',
      exportFileProvince: 'Province-coloect-most-point.xls',
      exportFile: 'รายชื่อผู้ใช้ที่จะถูกตัดคะแนนประจำเดือน.xls',
      exportWorksheet: 'WorkSheet',
      apiKey: 'AIzaSyCnDosnYWNnKQxLbsI5Cy_iw_VC5oyc1Ck', // Replace with your API key
      latitude: 40.714224, // Example latitude
      longitude: -73.961452, // Example longitude
      provinceDataLeaderBoard: [],
      memberDataLeaderBoard: [],
      provinceDataLeaderBoardData: [],
      memberDataLeaderBoardData: [],
      dataLeaderBoard: []
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // navigator.geolocation.getCurrentPosition((position) => {
    //   console.log(position.coords.latitude)
    // })
    // this.getQRCodeLotPosition()
    this.getDataBranch()
    this.getProductExchangeRate()
    this.dataReady = false
    // Get Data

    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )

    this.dataItem1.map((item) => {
      item.branchAndLotName = item.lotName + ' **' + ' (' + item.branchName + ')'
    })
    console.log('this.dataItem1', this.dataItem1)
    // await this.filter()
    await this.getQrCodeAddress()
    // this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId + '&status=waiting')
    // console.log('xxxx', this.dataItem)
  },
  methods: {
    // exportMemberTopCollectPoint () {
    //   console.log(this.memberDataLeaderBoardData)
    // },
    // exportProvinceTopCollectPoint () {
    //   console.log(this.provinceDataLeaderBoardData)
    // },
    filterLotNameByBranch (branchId) {
      console.log('item', branchId)
      console.log('this.dataItem1', this.dataItem1)
      this.selectedItem = []
      this.lotIdForfilter = this.dataItem1.filter((item) => {
        return item.masBranchID === branchId
      })
      console.log('this.lotIdForfilter', this.lotIdForfilter)
    },
    filterZone (zone) {
      this.markers = []
      this.fliterNameZone = zone
      this.provinceDataLeaderBoard = this.provinceDataLeaderBoardData.filter((item) => {
        return item.zone === zone
      }).slice(0, 4)
      this.export_data_province = this.provinceDataLeaderBoardData.filter((item) => {
        return item.zone === zone
      })
      this.memberDataLeaderBoard = this.memberDataLeaderBoardData.filter((item) => {
        return item.zone === zone
      }).slice(0, 3)
      this.export_data_member = this.memberDataLeaderBoardData.filter((item) => {
        return item.zone === zone
      })
      // fi
      this.dataQrcodeLot.map((item) => {
        if (item.zone === zone) {
          this.markers.push({'position': { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }, 'clickable': true, 'draggable': true})
        }
      })
    },
    async getQrCodeAddress () {
      try {
        let dataId = []
        this.haveLocation = 0
        this.notLocation = 0
        this.provinceDataLeaderBoard = []
        this.memberDataLeaderBoard = []
        if (this.selectedItem === null) {
          this.selectedItem = []
        }
        if (this.selectedItem.length > 0 || this.selectBranch) {
          this.selectedItem = this.selectedItem
          console.log('selectedItem', this.selectedItem)
          let dataId = {
            lotId: this.selectedItem,
            branch: this.selectBranch
          }
          console.log('selectedItem', dataId)

          await axios.post(this.DNS_IP + '/findQRCode-filter', dataId)
            .then(response => {
              console.log('res', response.data)
              this.dataQrcodeLot = []
              this.dataHaveLocation = []
              if (Array.isArray(response.data)) {
                this.markers = []
                this.dataQrcodeLot = response.data
                this.allQrcode = response.data.length
                this.countGetQrcode = 0
                this.countUsedQrcode = 0
                this.haveLocation = 0
                this.notLocation = 0
                this.center1 = 0
                this.north = 0
                this.south = 0
                this.east = 0
                this.west = 0
                this.northEast = 0
                response.data.forEach((item) => {
                  if (item.latitude && item.longitude) {
                    console.log('cccc', item.latitude)
                    this.markers.push({'position': { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }, 'clickable': true, 'draggable': true})
                    // this.position.position = { lat: item.latitude, lng: item.longitude }
                  }
                  if (item.status === 'waiting') {
                    this.countGetQrcode += 1
                  }
                  if (item.status === 'used') {
                    this.countUsedQrcode += 1
                  }
                  if (item.latitude !== '' && item.latitude !== null && item.latitude !== 'None' && item.status === 'used') {
                    this.dataHaveLocation.push(item)
                    this.haveLocation += 1
                    console.log('item.zone', item.zone)
                    if (item.zone === 'เหนือ') {
                      this.north += 1
                    } else if (item.zone === 'ตะวันออกเฉียงเหนือ') {
                      this.northEast += 1
                    } else if (item.zone === 'กลาง') {
                      this.center1 += 1
                    } else if (item.zone === 'ตะวันออก') {
                      this.east += 1
                    } else if (item.zone === 'ตะวันตก') {
                      this.west += 1
                    } else if (item.zone === 'ใต้') {
                      this.south += 1
                    }
                  } else {
                    if (item.status === 'used') {
                      this.notLocation += 1
                    }
                  }
                })
                console.log('this.position3', this.markers)
              } else {
                this.$swal({
                  title: 'ไม่พบข้อมูลที่คุณต้องการค้นหา?',
                  type: 'error'
                })
              }
              this.countProvince()
              this.countMember()
            // if (Array.isArray(res.data)) {
            //   this.dataQrcodeLot = res.data
            //   this.dataQrcodeLot.forEach((item) => {
            //     if (item.latitude !== '' && item.latitude !== null && item.latitude !== 'None') {
            //       this.haveLocation += 1
            //     } else {
            //       this.notLocation += 1
            //     }
            //   })
            // } else {
            //   this.dataQrcodeLot = null
            // }
            // console.log('this.dataQrcodeLot', this.dataQrcodeLot)
            }).catch(error => console.log(error))
        } else {
          this.dataItem1.forEach(item => dataId.push(item.lotId))
          await axios.post(this.DNS_IP + '/findQRCode', dataId)
            .then(res => {
              console.log('res', res.data)
              this.dataQrcodeLot = []
              this.dataHaveLocation = []
              if (Array.isArray(res.data)) {
                this.markers = []
                this.countGetQrcode = 0
                this.countUsedQrcode = 0
                this.haveLocation = 0
                this.notLocation = 0
                this.center1 = 0
                this.north = 0
                this.south = 0
                this.east = 0
                this.west = 0
                this.northEast = 0
                this.dataQrcodeLot = res.data
                this.dataQrcodeLot.forEach((item) => {
                  if (item.latitude !== '' && item.latitude !== null && item.latitude !== 'None' && item.status === 'used') {
                    this.haveLocation += 1
                    this.dataHaveLocation.push(item)
                    if (item.zone === 'เหนือ') {
                      this.north += 1
                    } else if (item.zone === 'ตะวันออกเฉียงเหนือ') {
                      this.northEast += 1
                    } else if (item.zone === 'กลาง') {
                      this.center1 += 1
                    } else if (item.zone === 'ตะวันออก') {
                      this.east += 1
                    } else if (item.zone === 'ตะวันตก') {
                      this.west += 1
                    } else if (item.zone === 'ใต้') {
                      this.south += 1
                    }
                  } else {
                    if (item.status === 'used') {
                      this.notLocation += 1
                    }
                  }
                })
                this.dataQrcodeLot.filter((item) => {
                  if (item.latitude && item.longitude) {
                    console.log('cccc', item.latitude)
                    this.markers.push({'position': { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }, 'clickable': true, 'draggable': true})
                    // this.position.position = { lat: item.latitude, lng: item.longitude }
                  }
                })
              } else {
                this.dataQrcodeLot = null
              }
            }).catch(error => console.log(error))
          this.allQrcode = this.dataItem1.reduce(
            (accumulator, currentValue) => accumulator + currentValue.Count,
            0
          )
          this.countUsedQrcode = this.dataItem1.reduce(
            (accumulator, currentValue) => accumulator + currentValue.Uses,
            0
          )
          this.countGetQrcode = this.dataItem1.reduce(
            (accumulator, currentValue) => accumulator + currentValue.Gets,
            0
          )
          // this.dataHaveLocation.forEach((item) => {
          //   console.log('dataHaveLocation', item)
          // })
          this.countProvince()
          this.countMember()
        }
      } catch (error) {
        console.log('getQrCodeAddress error', error)
      }
    },
    async countMember () {
      this.memberDataLeaderBoardData = this.dataQrcodeLot.filter((item) => {
        return item.status === 'used'
      }).reduce((accumulator, currentValue) => {
        const memberId = currentValue.memberId
        const existingMember = accumulator.find(item => item.memberId === memberId)
        if (existingMember) {
          existingMember.count++
        } else {
          accumulator.push({ ...currentValue, count: 1 })
        }
        return accumulator
      }, []).sort(function (a, b) {
        return b.count - a.count
      })
      this.export_data_member = this.memberDataLeaderBoardData
      this.memberDataLeaderBoard = this.memberDataLeaderBoardData.slice(0, 3)
      console.log('this.memberDataLeaderBoardData', this.memberDataLeaderBoardData)
    },
    async countProvince () {
      this.provinceDataLeaderBoardData = this.dataHaveLocation.reduce((accumulator, currentValue) => {
        const { province, zone } = currentValue
        const existingEntry = accumulator.find(item => item.province === province && item.zone === zone)
        if (existingEntry) {
          existingEntry.count++
        } else {
          accumulator.push({ province, count: 1, zone })
        }
        return accumulator
      }, []).sort(function (a, b) {
        return b.count - a.count
      })
      this.export_data_province = this.provinceDataLeaderBoardData
      this.provinceDataLeaderBoard = this.provinceDataLeaderBoardData.slice(0, 4)
      console.log('provinceData', this.provinceDataLeaderBoardData)
      // this.provinceDataLeaderBoard = Object.entries(this.provinceDataLeaderBoard).map(([province, count]) => ({ province, count })).sort(function (a, b) {
      //   return b.count - a.count
      // })

      console.log('provinceData', this.provinceDataLeaderBoard)
    },
    updatePlace (place) {
      // console.log(place)
      this.center = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng()
      }
    },
    getQRCodeLotPosition () {
      axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/qrcode/' + 'get?status=used&statusLot=yes&shopId=' + this.session.data.shopId
        )
        .then(async response => {
          console.log('getQRCodeLotPosition', response)
          if (Array.isArray(response.data)) {
            response.data.filter((item) => {
              if (item.latitude && item.longitude) {
                console.log('cccc', item.latitude)
                this.markers.push({'position': { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) }, 'clickable': true, 'draggable': true})
                // this.position.position = { lat: item.latitude, lng: item.longitude }
              }
            })
            console.log('this.position3', this.markers)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    async printer (item) {
      this.dataReady = false
      this.print = []
      await axios
        .get(
          this.DNS_IP + '/productExchangeRate/' + 'get?productExchangeRateId=' + item.productExchangeRateId
        )
        .then(async response => {
          console.log('response >>>>', response.data[0].multiplyPoint)
          if (response.data[0].multiplyPoint) {
            let startDate = new Date(response.data[0].startMultiplyPoint).setHours(0, 0, 0, 0)
            let endDate = new Date(response.data[0].endMultiplyPoint).setHours(0, 0, 0, 0)
            var todaysDate = new Date().setHours(0, 0, 0, 0)
            if (startDate <= todaysDate && endDate >= todaysDate) {
              this.multiplyPoint = response.data[0].multiplyPoint
              this.pointMultiply = this.multiplyPoint
            } else {
              this.pointMultiply = null
            }
          } else {
            this.pointMultiply = null
          }
        })
      await axios
        .get(
          this.DNS_IP + '/qrcode/' + 'get?status=waiting&lotId=' + item.lotId
        )
        .then(async response => {
          this.dataReady = true
          let printqr = response.data
          let qrcode = []
          for (let i = 0; i < printqr.length; i++) {
            let qr = printqr[i]
            let s = {}
            // let b = {}
            if (qr.qrCodeURL !== '') {
              s.qr = qr.qrCodeURL
              if (this.pointMultiply) {
                s.point = qr.point * this.pointMultiply
              } else {
                s.point = qr.point
              }
              qrcode.push(s)
            }
          }
          let content = []
          let q = { columns: [] }
          let arris3 = function () {
            return [{ text: '   ' }]
          }
          if (this.session.data.shopId !== 'U8e5495902728477dd8eb9167cbb624ed') {
            qrcode.map((a, i) => {
              if (q.columns.length < 5) {
                q.columns.push([
                  { qr: a.qr, fit: '90', alignment: 'center' },
                  {
                    text: 'จำนวน' + ' ' + a.point + ' ' + 'คะแนน',
                    alignment: 'center'
                  }
                ])
                if (i === qrcode.length - 1) {
                  content.push({ columns: [...q.columns] })
                  content.push(arris3())
                }
              } else if (q.columns.length > 4) {
                content.push({ columns: [...q.columns] })
                content.push(arris3())
                q.columns = []
                q.columns.push([
                  { qr: a.qr, fit: '90', alignment: 'center' },
                  {
                    text: 'จำนวน' + ' ' + a.point + ' ' + 'คะแนน',
                    alignment: 'center'
                  }
                ])
              }
            })
            const docDefinition = {
              pageSize: 'A4',
              content: content,
              defaultStyle: {
                font: 'Kanit'
              }
            }
            pdfMake.vfs = pdfFonts.pdfMake.vfs
            pdfMake.fonts = {
              Roboto: {
                normal:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                bold:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                italics:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                bolditalics:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
              },
              Kanit: {
                normal: 'Kanit-Regular.ttf',
                bold: 'Kanit-Medium.ttf',
                italics: 'Kanit-Italic.ttf',
                bolditalics: 'Kanit-MediumItalic.ttf'
              }
            }
            pdfMake.createPdf(docDefinition).getDataUrl(function (outDoc) {
              document.getElementById('pdfV').src = outDoc
            })
          } else {
            qrcode.map((a, i) => {
              if (q.columns.length < 10) {
                q.columns.push([
                  {
                    text: 'MICS',
                    alignment: 'center',
                    fontSize: 15,
                    bold: true,
                    color: '#0a5b6e',
                    margin: [0, 0, 0, 3],
                    font: 'Kanit'
                  },
                  {
                    text: 'ตรวจเช็ตสินค้า\nและรับแต้ม',
                    alignment: 'center',
                    fontSize: 5,
                    bold: true, // เพิ่ม bold เพื่อให้เป็น font weight
                    color: '#0a5b6e',
                    margin: [0, 0, 0, 1]
                  },
                  { qr: a.qr, fit: '51.02', alignment: 'center', padding: [2, 2, 2, 2] },
                  {
                    text: +a.point + ' ' + 'คะแนน',
                    alignment: 'center',
                    fontSize: 7
                  }
                ])
                if (i === qrcode.length - 1) {
                  content.push({ columns: [...q.columns] })
                  content.push(arris3())
                }
              } else if (q.columns.length > 4) {
                content.push({ columns: [...q.columns] })
                content.push(arris3())
                q.columns = []
                q.columns.push([
                  { qr: a.qr, fit: '51.02', alignment: 'center' },
                  {
                    text: a.point + ' ' + 'คะแนน',
                    alignment: 'center',
                    fontSize: 10
                  }
                ])
              }
            })
            console.log('content', content)
            const docDefinition = {
              pageSize: 'A3',
              // pageOrientation: 'landscape',
              content: content,
              defaultStyle: {
                // 4. default style 'KANIT' font to test
                font: 'Kanit'
              }
            }
            pdfMake.vfs = pdfFonts.pdfMake.vfs // 2. set vfs pdf font
            pdfMake.fonts = {
              // download default Roboto font from cdnjs.com
              Roboto: {
                normal:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
                bold:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
                italics:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
                bolditalics:
                  'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
              },
              // Kanit Font
              Kanit: {
                // 3. set Kanit font
                normal: 'Kanit-Regular.ttf',
                bold: 'Kanit-Medium.ttf',
                italics: 'Kanit-Italic.ttf',
                bolditalics: 'Kanit-MediumItalic.ttf'
              }
            }
            pdfMake.createPdf(docDefinition).getDataUrl(function (outDoc) {
              document.getElementById('pdfV').src = outDoc
            })
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    async printerV2 (item) {
      this.print = []

      const getEx = await axios.get(this.DNS_IP + '/productExchangeRate/' + 'get?productExchangeRateId=' + item.productExchangeRateId)
      try {
        if (getEx.data[0].multiplyPoint) {
          let startDate = new Date(getEx.data[0].startMultiplyPoint).setHours(0, 0, 0, 0)
          let endDate = new Date(getEx.data[0].endMultiplyPoint).setHours(0, 0, 0, 0)
          var todaysDate = new Date().setHours(0, 0, 0, 0)
          if (startDate <= todaysDate && endDate >= todaysDate) {
            this.multiplyPoint = getEx.data[0].multiplyPoint
            this.pointMultiply = this.multiplyPoint
          } else {
            this.pointMultiply = null
          }
        } else {
          this.pointMultiply = null
        }
      } catch (err) {
        this.pointMultiply = null
      }

      const response = await axios.get(this.DNS_IP + '/qrcode/' + 'get?status=waiting&lotId=' + item.lotId)
      let printqr = response.data
      console.log('printqr >>', printqr)
      let qrcode = []
      let chk = 1
      let chkStart = 0
      let arrCol = []
      for await (let qr of printqr) {
        let points = 0
        if (qr.qrCodeURL !== '') {
          if (this.pointMultiply) {
            points = qr.point * this.pointMultiply
          } else {
            points = qr.point
          }
          arrCol.push(
            [
              {
                'qr': qr.qrCodeURL,
                'fit': '90',
                'alignment': 'center'
              },
              {
                'text': 'จำนวน ' + points + ' คะแนน',
                'alignment': 'center'
              }
            ]
          )
          console.log('chk: ', chk, chk % 4)

          if (chk % 5 === 0 && chkStart !== 0) {
            qrcode.push(
              {
                columns: arrCol
              }
            )
            qrcode.push(
              [
                // { qr: qr.qrCodeURL, fit: '51.02', alignment: 'center' },
                {
                  text: '    ',
                  alignment: 'center',
                  fontSize: 10
                }
              ]
            )
            chk = 0
            arrCol = []
          }

          chkStart++
          chk++
        }
      }

      if (printqr.length <= 5) {
        qrcode.push(
          {
            columns: arrCol
          }
        )
        qrcode.push(
          [
            // { qr: qr.qrCodeURL, fit: '51.02', alignment: 'center' },
            {
              text: '    ',
              alignment: 'center',
              fontSize: 10
            }
          ]
        )
      }
      console.log('qrcode >>', qrcode)

      const docDefinition = {
        pageSize: 'A4',
        content: qrcode,
        defaultStyle: {
          font: 'Kanit'
        }
      }
      qrcode = []
      pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.fonts = {
        Roboto: {
          normal:
                'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
          bold:
                'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
          italics:
                'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
          bolditalics:
                'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
        Kanit: {
          normal: 'Kanit-Regular.ttf',
          bold: 'Kanit-Medium.ttf',
          italics: 'Kanit-Italic.ttf',
          bolditalics: 'Kanit-MediumItalic.ttf'
        }
      }
      try {
        pdfMake.createPdf(docDefinition).download('QRCode.pdf')
        this.loadingBTN = false
        this.$swal('ไฟล์จะปรากฏในช่อง Download', 'หากไฟล์ไม่ปรากฏกรุณารอสักครู่', 'question')
      } catch (err) {
        console.log('err', err)
      }
    },
    chkaddFilterItem () {
      if (this.filterItem.length === 1) {
        this.addExchange(this.filterItem)
      }
    },
    chkaddProductExchangeRate () {
      if (this.ProductExchangeRate.length === 1) {
        this.addExchange(this.ProductExchangeRate)
      }
    },
    addExchange (item) {
      if (this.session.data.userTypeGroup === 'Operation') {
        if (this.filterItem.length === 1) {
          this.formAdd.productExchangeRateId = item[0].value
          this.Exchange = item[0].text
        } else {
          this.formAdd.productExchangeRateId = item.value
          this.Exchange = item.text
        }
      } else if (this.session.data.userTypeGroup !== 'Operation') {
        if (this.ProductExchangeRate.length === 1) {
          this.formAdd.productExchangeRateId = item[0].value
          this.Exchange = item[0].text
        } else {
          this.formAdd.productExchangeRateId = item.value
          this.Exchange = item.text
        }
      } else {
        this.formAdd.productExchangeRateId = item.value
        this.Exchange = item.text
      }

      console.log('item', item)
    },
    async filter () {
      this.filterItem = []
      this.ProductExchangeRate.forEach(element => {
        JSON.parse(element.userId).forEach(el => {
          if (el === this.session.data.userId) {
            this.filterItem.push(element)
          }
        })
      })
      console.log('oooo', this.filterItem)
    },
    async getDataBranch () {
      this.dataBranch = []
      await axios
        .get(
          this.DNS_IP +
            '/master_branch/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.masBranchID
            s.text = d.masBranchName
            d = s
            this.dataBranch.push(d)
          }
          console.log('getDataCompany : ', this.dataBranch)
          if (this.dataBranch.length === 1) {
            this.formAdd.masBranchID = s.value
            console.log('masBranch', this.formAdd.masBranchID)
          }
        })
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'ADDLOT':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_addLot.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getProductExchangeRate () {
      this.ProductExchangeRate = []
      await axios
        .get(
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            s.userId = d.userId
            d = s
            console.log(d)
            this.ProductExchangeRate.push(d)
          }
        })
      console
        .log('this.ProductExchangeRate : ', this.ProductExchangeRate)
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async searchDataAll () {
      var search =
        '?id=' +
        this.searchAll +
        '&productExchangeRateId=' +
        this.searchAll +
        '&amount=' +
        this.searchAll
      this.dataReady = false
      this.searchDataAllGlobal(this.DNS_IP, this.path, search, this.returnLink)
    },
    async getDataById (item) {
      this.dataReady = false
      this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
    },
    async getDataQRCode (dt) {
      this.dataReady = false
      this.dataViewQR = []
      await axios
        .get(
          this.DNS_IP +
            '/qrcode/' +
            'get?status=waiting&lotId=' +
            dt.lotId +
            '&shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          this.dataReady = true
          this.dataViewQR = response.data
          console.log('this.dataViewQR', this.dataViewQR)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
          this.dataReady = true
        })
    },
    async addData () {
      this.dataReady = false
      this.dataShowQR = false

      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          const today = new Date()
          // console.log(today)
          const date =
            today.getFullYear() +
            '' +
            (today.getMonth() + 1) +
            '' +
            today.getDate()
          const time =
            today.getHours() + '' + today.getMinutes() + '' + today.getSeconds()
          const lotId = date + '' + time
          var productExchangeRateId = this.formAdd.productExchangeRateId

          var dateExchange = this.ProductExchangeRate.filter(function (el) {
            return el.value === productExchangeRateId
          })
          let _this = this
          var dateBranchs = this.dataBranch.filter(function (el) {
            return el.value === _this.formAdd.masBranchID
          })
          this.formAdd.branchName = dateBranchs[0].text
          // console.log(dateExchange[0].exchangeRate)
          var point =
            parseInt(this.formAdd.amount) / dateExchange[0].exchangeRate
          // console.log(point)
          this.formAdd.CREATE_USER = this.session.data.userName
          this.formAdd.LAST_USER = this.session.data.userName
          this.formAdd.point = parseInt(point)
          this.formAdd.lotId = lotId
          const resultConfig = await axios.get(this.DNS_IPBelink + `/lineconfig/get?shopId=${this.$session.getAll().data.shopId}`)
          if (Array.isArray(resultConfig.data)) {
            if (resultConfig.data[0].liffMainIDLoyalty !== null) {
              this.formAdd.liffId = resultConfig.data[0].liffMainIDLoyalty
            } else {
              this.formAdd.liffId = '1656906322-JN5MM8Ep'
            }
          } else {
            this.formAdd.liffId = '1656906322-JN5MM8Ep'
          }
          // this.formAdd.liffId = process.env.VUE_APP_LIFF_ID
          // this.formAdd.statusLot = 'no'
          this.formAdd.shopId = this.$session.getAll().data.shopId
          // this.formAdd.qrCodeURL = 'http://localhost:8081/collect?token=' + this.formAdd.token
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              this.formAdd
              //   {
              //     headers: {
              //       'Application-Key': this.$session.getAll().ApplicationKey
              //     }
              //   }
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)

              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false
              // this.dataShowQR = true
              // this.dialogViewAdd = true

              // Load Data
              await this.clearData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
              this.dataReady = true
            })
          this.loadingAdd = false
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async editData () {
      // this.editDataGlobal(this.DNS_IP, this.path, this.PK, this.formUpdateItem)
      this.dataReady = false

      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          // this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.id
          this.formUpdateItem.lotName = this.formUpdate.lotName
          this.formUpdateItem.LAST_USER = this.session.data.userName
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdateItem
              // {
              //   headers: {
              //     'Application-Key': this.$session.getAll().ApplicationKey
              //   }
              // }
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
          this.loadingEdit = false
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '&status=waiting',
        this.returnLink
      )
    },
    chkAdd () {
      this.res = []
      axios
        .get(this.DNS_IP + '/only_shop/get?shopId=' + this.session.data.shopId)
        .then(response => {
          let rs = response.data[0].billingPlan
          console.log('rs', rs)
          if (rs === 'billing') {
            alert('billing')
          } else {
            axios
              .get(
                this.DNS_IP +
                  '/member/Member?shopId=' +
                  this.session.data.shopId
              )
              .then(response => {
                this.res = response.data
                console.log(this.res)
              })
          }
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      this.formAdd.productExchangeRateId = ''
      this.formAdd.amount = 0
      this.formAdd.point = 0
      this.formAdd.status = 'waiting'
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.formAdd.shopId = ''
      this.formAdd.lotId = ''
      this.formAdd.countLot = ''
      this.formAdd.branchName = ''
      this.formAdd.masBranchID = ''
      this.formAdd.lotName = ''
      // eslint-disable-next-line no-redeclare
      // for (var key in this.search) {
      //   if (this.search[key]) {
      //     this.search[key] = ''
      //   }
      // }
    }
  }
}
</script>
<style scoped>
.frameQR {
  background: linear-gradient(to right, black 50%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(black 50%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(to right, black 50%, rgba(255, 255, 255, 0) 0%),
    linear-gradient(black 50%, rgba(255, 255, 255, 0) 0%);
  background-position: top, right, bottom, left;
  background-repeat: repeat-x, repeat-y;
  background-size: 21px 1px, 1px 21px;
  min-width: 170px !important;
}
.shopname {
  font-size: 15px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 15px;
}
.point {
  font-size: 12px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#subtext {
  color: #173053;
  font-size: 20px !important;
  font-weight: bold;
}
#margin {
  margin-top: 30px;
  margin-bottom: 70px;
}
#img_size {
  width: 187.94px;
  height: 385.15px;
  margin-top: 100px;
  margin-left: 100px;
}
.box {
  text-transform: uppercase;
  transition: all 0.3s;
  position: relative;
  z-index: 1;
  cursor: pointer;
}
.box:hover {
  transform: translateY(-7px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
}
.cardMap {
  border-radius: 20px !important;
  padding: 20px;
}
.cardMap2 {
  border-radius: 5px !important;
  padding: 10px;
}
.card-titel-ja{
  text-align: center;
  background: grey;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
  color: white;
  padding: 10px;
}
.hovering{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/CollectQRCodeLot.vue